import { render, staticRenderFns } from "./fascia.vue?vue&type=template&id=47988cc0&"
import script from "./fascia.vue?vue&type=script&lang=js&"
export * from "./fascia.vue?vue&type=script&lang=js&"
import style0 from "./fascia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports